export default function UHeaderRightButtons(props) {
  return props.children
}
